import { render, staticRenderFns } from "./FollowIntroduction.vue?vue&type=template&id=97faee72&scoped=true&"
import script from "./FollowIntroduction.vue?vue&type=script&lang=js&"
export * from "./FollowIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97faee72",
  null
  
)

export default component.exports